/**
 * TOPページのスライドショーを全幅表示にする
 * #MainContentの外に移動して、サイドバーの影響を受けないようにする
 */

(function() {
  'use strict';

  console.log('sidebar-slider-fix.js: スクリプトが読み込まれました');

  // TOPページの判定（複数の方法で確認）
  const pathname = window.location.pathname;
  const mainContent = document.getElementById('MainContent');
  const dataTemplate = mainContent ? mainContent.getAttribute('data-template') : null;
  
  // パス名がルートまたは言語コードのみの場合（/、/ja-jp、/en、/ja-jp/など）
  const isRootPath = pathname === '/' || 
                      pathname.match(/^\/[a-z]{2}(-[a-z]{2})?\/?$/) !== null ||
                      pathname === '/index';
  
  // data-template属性がindexの場合
  const isIndexTemplate = dataTemplate === 'index';
  
  // bodyクラスで確認
  const hasIndexClass = document.body.classList.contains('template-index');
  
  const isIndexPage = isRootPath || isIndexTemplate || hasIndexClass;

  console.log('TOPページ判定:', {
    'pathname': pathname,
    'isRootPath': isRootPath,
    'data-template': dataTemplate,
    'isIndexTemplate': isIndexTemplate,
    'template-index class': hasIndexClass,
    'isIndexPage': isIndexPage
  });

  if (!isIndexPage) {
    console.log('TOPページではないため、処理をスキップします');
    return;
  }

  console.log('TOPページです。スライドショーの移動を開始します');

  function moveSliderToFullWidth() {
    // 既に移動済みの場合は何もしない
    if (document.querySelector('.slider-moved')) {
      return;
    }

    const mainContent = document.getElementById('MainContent');
    if (!mainContent) return;

    // スライドショーセクションを検索（複数の方法で検索）
    const sections = mainContent.querySelectorAll('.shopify-section');
    let sliderSection = null;
    
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      
      // 方法1: custom-swiper-outer-wrapperクラスで検索
      if (section.querySelector('.custom-swiper-outer-wrapper')) {
        sliderSection = section;
        break;
      }
      
      // 方法2: custom-swiper-containerクラスで検索
      if (section.querySelector('.custom-swiper-container')) {
        sliderSection = section;
        break;
      }
      
      // 方法3: section--full-widthクラスとcustom-swiperの組み合わせ
      if (section.classList.contains('section--full-width') && 
          (section.querySelector('.custom-swiper-outer-wrapper') || 
           section.querySelector('.custom-swiper-container'))) {
        sliderSection = section;
        break;
      }
    }
    
    if (!sliderSection) {
      console.log('スライドショーセクションが見つかりませんでした');
      return;
    }

    console.log('スライドショーセクションを検出:', sliderSection);

    // ページコンテナを取得
    const pageWithSidebar = document.querySelector('.page-with-sidebar');
    if (!pageWithSidebar) {
      console.log('page-with-sidebarが見つかりませんでした');
      return;
    }

    // スライドショーセクションをpage-with-sidebarの外に移動
    // page-with-sidebarの前に配置
    if (pageWithSidebar.parentNode) {
      // スライドショーを全幅クラスを追加
      sliderSection.classList.add('slider-full-width', 'slider-moved');
      
      console.log('スライドショーを移動します');
      
      // page-with-sidebarの前に挿入
      pageWithSidebar.parentNode.insertBefore(sliderSection, pageWithSidebar);
      
      console.log('スライドショーの移動が完了しました');
    }
  }

  // 複数のタイミングで実行を試みる
  function tryMoveSlider() {
    // 少し遅延させて、DOMが完全に構築されるのを待つ
    setTimeout(moveSliderToFullWidth, 100);
  }

  // DOMContentLoaded後に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryMoveSlider);
  } else {
    tryMoveSlider();
  }

  // window.load後にも実行（画像などが読み込まれた後）
  window.addEventListener('load', tryMoveSlider);

  // Shopify Admin Editor用
  document.addEventListener('shopify:section:load', tryMoveSlider);
  document.addEventListener('shopify:section:select', tryMoveSlider);
  document.addEventListener('shopify:section:deselect', tryMoveSlider);

  // MutationObserverでDOMの変更を監視（セクションが動的に追加される場合に対応）
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      // スライドショーがまだ移動されていない場合のみ実行
      if (!document.querySelector('.slider-moved')) {
        tryMoveSlider();
      }
    });
    
    const mainContent = document.getElementById('MainContent');
    if (mainContent) {
      observer.observe(mainContent, {
        childList: true,
        subtree: true
      });
    }
  }
})();
